import { render, staticRenderFns } from "./FaturaGonderim.vue?vue&type=template&id=203dc776&"
import script from "./FaturaGonderim.vue?vue&type=script&lang=js&"
export * from "./FaturaGonderim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports